import { Box, Card, CardContent, Divider, Link, Typography } from '@material-ui/core';

export const GettingStartedComponent = () => (
  <Card>
    <CardContent>
      <Box display="flex" flexDirection="column" gridGap={8}>
        <Typography gutterBottom variant="h6">
          Getting started
        </Typography>
        <Typography gutterBottom variant="body2">
          This Notifications Feature is designed to streamline the process of
          sending notifications to consumers of your APIs by leveraging the
          standard relationships provides APIs and consumes APIs). You can
          easily communicate important information regarding incidents, security
          incidents, maintenance or updates ensuring that all stakeholders are
          proactively informed. Notifications will be send by E-Mail and inside
          the ZEISS Developer Portal.
        </Typography>
        <Typography gutterBottom variant="body2">
          <Link href="https://developer.zeiss.com/docs/default/system/zeiss-developer-portal/notifications/">
            Additional Docs
          </Link>
        </Typography>
        <Divider />
        <Typography gutterBottom variant="h6">
          Who will notified?
        </Typography>
        <Typography gutterBottom variant="body2">
          Component owning user or teams if configured that are linked with
        </Typography>
        <Divider />
        <Typography gutterBottom variant="h6">
          Use Cases
        </Typography>
        <ol style={{ marginTop: 0 }}>
          <li>
            Incident communication
            <ul>
              <li>You want to communicate a Service is degraded or down</li>
              <li>
                You want to communicate your Service is up again and available
              </li>
            </ul>
          </li>
          <li>
            Security Incident communication
            <ul>
              <li>You want to communicate a Service is degraded or down</li>
              <li>
                You want to communicate your Service is up again and available
              </li>
            </ul>
          </li>
          <li>
            Maintenance Window communication
            <ul>
              <li>
                You want to communicate there will be a scheduled down time
              </li>
              <li>
                You want to communicate there will be a scheduled service
                degradation
              </li>
            </ul>
          </li>
          <li>
            Update available communication
            <ul>
              <li>
                You are a Library owner or a API Owner and want to inform your
                consumers about new features
              </li>
            </ul>
          </li>
        </ol>
      </Box>
    </CardContent>
  </Card>
);
